// extracted by mini-css-extract-plugin
export default {"customCheckbox":"CustomCheckbox_customCheckbox__pCtpF"};